import React from "react";
import { ReactComponent as LoaderSVG } from "../../assets/svg/loader.svg";
import styles from "./styles.css";

export default props => {
  return (
    <div className="loader-anim-holder">
      <LoaderSVG />
    </div>
  );
};
